<template>
	<div class="shop-product-check">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Sync Changes</h1>
		<p class="description">
			This page will display list of changes yet to be synced
		</p>

		<b-field label="Select Shop To Clean Sync Changes (Optional)">
			<b-autocomplete
				v-model="cleanShopsSuggetions"
				:data="filteredCleanShops"
				:open-on-focus="true"
				placeholder="Shop"
				field="name"
				@select="option => (cleanShopsSelected = option)"
				class="shopAutoComplete"
			>
				<template slot="empty">No results found</template>
			</b-autocomplete>
		</b-field>

		<div class="button-container" @click="confirmCleanSyncChanges()">
			<div class="big-button">
				CLEAN SYNC CHANGES
			</div>
		</div>

		<div class="single-text-wrapper">
			<b-field label="Action (Optional)">
				<b-input v-model="action" placeholder="Action (create, update, disable, replace)" @keyup.native.enter="getSyncChanges()"></b-input>
			</b-field>
		</div>

		<div class="content-wrapper">
			<div class="single-text-wrapper">
				<b-field label="Page Number (Optional)">
					<b-input v-model="page" placeholder="Page number" @keyup.native.enter="getSyncChanges()"></b-input>
				</b-field>
			</div>

			<b-field label="Select Shop (required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="button-container" @click="getSyncChanges()">
				<div class="big-button">
					Check Sync Log
				</div>
			</div>

			<div class="progress" v-if="totalSyncChanges > 0">There are {{ totalSyncChanges }} to be synced</div>
		</div>

		<div v-if="allShopSync.length > 0">
			<div v-for="(item, index) of allShopSync" :key="index" class="all-shop-sync-list">
				<div>{{ item.shop_name }}</div>
				<div>{{ item.total }}</div>
			</div>
		</div>

		<div v-if="syncList.length > 0">
			<div v-for="(item, index) of syncList" :key="index" class="sync-list">
				<div>{{ item.action }}</div>
				<div>{{ item.name }}</div>
				<div>{{ convertTime(item.createdAt) }}</div>
				<div>
					<b-collapse :open="false" aria-id="contentIdForA11y1">
						<button class="button is-primary" slot="trigger" aria-controls="contentIdForA11y1">Data</button>
						<div class="notification">
							<div class="content">
								<pre>
										{{ item }}
									</pre
								>
							</div>
						</div>
					</b-collapse>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	title: 'Sync Changes',
	name: 'productsCheck',
	data: () => ({
		limit: 20,
		isLoading: false,
		shops: [],
		shopsSuggestions: '',
		selectedShop: null,
		cleanShops: [],
		cleanShopsSuggetions: '',
		cleanShopsSelected: null,
		page: 1,
		totalSyncChanges: 0, // Total number of changes
		syncList: [], // To display in list
		action: null, // For textbox above
		allShopSync: []
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getShops()
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredCleanShops() {
			return this.cleanShops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.cleanShopsSuggetions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		confirmCleanSyncChanges: function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to DELETE disabled shop sync changes?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes!'
				})
				.then(result => {
					if (result.value) {
						this.cleanSyncChanges()
					}
				})
		},

		cleanSyncChanges: async function() {
			let data = {}

			if (this.cleanShopsSelected !== null) {
				data.shop = this.cleanShopsSelected._id

				await this.$api.cleanSyncChanges({ data })
			} else {
				await this.$api.cleanSyncChanges({ data })

				this.cleanShops.map(async shop => {
					data.shop = shop._id

					await this.$api.cleanSyncChanges({ data })
				})
			}

			this.$swal.fire('Complete!', 'Done!', 'success')
		},

		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		// Verify if the brand ID and values are valid
		getSyncChanges: async function() {
			if (this.selectedShop == null || !this.selectedShop._id) {
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Please select a shop!'
				})

				return
			}

			this.allShopSync = []
			this.syncList = []
			this.totalSyncChanges = 0
			this.isLoading = true

			var page = this.page > 0 ? this.page : 1

			if (this.selectedShop._id == 'all') {
				this.getAllShopsSync()
				return
			}

			let skip = (page - 1) * this.limit

			var data = {
				limit: this.limit,
				status: true,
				skip,
				data: {
					shop: this.selectedShop._id
				}
			}

			if (this.action !== null && this.action !== '') {
				data.action = this.action
			}

			const syncChanges = await this.$api.syncChanges({ data })

			if (syncChanges !== undefined) {
				let total = syncChanges.data.total
				this.totalSyncChanges = total

				this.syncList = syncChanges.data.list

				if (total == 0) {
					this.$swal.fire('Sync!', 'Everything is synced!', 'success')
				}
			}

			this.isLoading = false
		},

		getAllShopsSync: async function() {
			Promise.all(
				this.shops.map(async shop => {
					if (shop._id !== 'all') {
						var data = {
							limit: 1,
							status: true,
							data: {
								shop: shop._id
							}
						}

						if (this.action !== null && this.action !== '') {
							data.action = this.action
						}

						const syncChanges = await this.$api.syncChanges({ data })

						if (syncChanges !== undefined) {
							let total = syncChanges.data.total

							let data = {
								shop_name: shop.name,
								total
							}

							this.allShopSync.push(data)
						}

						this.isLoading = false
					}
				})
			)
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			apiGetShops.data.list.map(shop => {
				// Find and remove HO shops
				let find_ho = shop.name.indexOf('HO_')

				if (find_ho == -1) {
					this.shops.push(shop)
				}
				// else {
				// 	this.cleanShops.push(shop)
				// }

				this.cleanShops.push(shop)
			})

			this.shops.unshift({ code: 'ALL', name: 'ALL', _id: 'all' })
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
